import { api, toCamelCase } from '../lib/api'
import type {
  AdminUserDetail,
  AdminUserListResponse,
  AdminUserStats,
  GetUsersParams,
} from '../types/admin'
import type { User } from '../stores/authStore'

export const adminApi = {
  async getUsers(params: GetUsersParams = {}): Promise<AdminUserListResponse> {
    const response = await api.get('/admin/users', { params })
    return toCamelCase(response.data as Record<string, unknown>) as unknown as AdminUserListResponse
  },

  async getUserStats(): Promise<AdminUserStats> {
    const response = await api.get('/admin/users/stats')
    return toCamelCase(response.data as Record<string, unknown>) as unknown as AdminUserStats
  },

  async getUserDetail(userId: number): Promise<AdminUserDetail> {
    const response = await api.get(`/admin/users/${userId}`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as AdminUserDetail
  },

  async impersonateUser(userId: number): Promise<{ user: User; token: string }> {
    const response = await api.post(`/admin/impersonate/${userId}`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as {
      user: User
      token: string
    }
  },
}
